export default __webpack_public_path__ + "static/kinoklubb-black-dbf3e6745dd862b8caffb6c07d47e03d.png";